import doc                 from '@widesk-core/decorators/doc';
import AccountServiceModel from '@/models/AccountServiceModel';

@doc.path('/account_invitations/accept')
export default class AcceptAccountInvitationModel extends AccountServiceModel {
	@doc.string declare token: string;
	@doc.string declare account: Urn;
	@doc.string declare userAccount: Urn;
}
